// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.grow[data-v-db6e6d5a]{\n\t-webkit-box-flex:1;\n\t    -ms-flex-positive:1;\n\t        flex-grow:1;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
